import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalSportRepository} from './impl/service/ngrx/medicalSport.repository';
import {MedicalSportDataService} from './impl/service/ngrx/medicalSportData.service';
import {errorMessages} from '../../../core/error/errorMessages';
import {
    AI_REALTIME_TOOL_DEFINITIONS,
    AiRealtimeToolDefinition
} from "../../../ai/realtime/api/service/aiRealtime.service";

@NgModule({
    providers: [
        {
            provide: AI_REALTIME_TOOL_DEFINITIONS,
            useValue: [
                {
                    toolName: 'add_sports_to_consultation',
                    runningLabel: 'Ajout d\'un sport en cours',
                    errorLabel: 'Erreur lors de l’ajout de sports',
                    successLabel: 'Sport(s) ajouté(s)'
                } as AiRealtimeToolDefinition],
            multi: true,
        },
    ]
})
export class MedicalRecordSportModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: MedicalSportRepository,
                dataService: MedicalSportDataService,
    ) {

        entityDataService.registerServices({
            MedicalSport: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalRecordSport: repository,
        });

        errorMessages.set('MEDICAL_RECORD_SPORT_SAVE_END_YEAR_LESS_THAN_START_YEAR', 'L\'année de fin ne peut pas être antérieure à l\'année de début');
    }
}
